module.exports = __webpack_public_path__ + "img/68.04471c03.webp";